module.exports = __webpack_public_path__ + "static/img/office (15).2df8d0ef.jpg";